// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-wrapper .focusable-div:focus button.skip-video-controllers{opacity:1;pointer-events:auto}", ""]);
// Exports
module.exports = exports;
